import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import '../../servicestypes/webdevelopment/webdevservices.css'; // Import the CSS file
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import Digitalimage1 from '../../../assests/digital marketing.jpeg';

const Digitalmarketing = () => {
  return (
    <Card className="webdevelopment-card">
      {/* Left side with image */}
      <Grid item xs={12} md={4} className="webdevelopment-image-container">
        <Box
          component="img"
          className="webdevelopment-image"
          alt="Digital Marketing"
          src={Digitalimage1}
        />
        
        {/* Contact Information */}
        <div className="contact-info">
          <Typography variant="h6" component="div" gutterBottom className="contact-title">
            Contact Information
          </Typography>
          <div className="contact-item">
            <PhoneIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">+919060237575</Typography>
          </div>
          <div className="contact-item">
            <EmailIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Faridiakram41@gmail.com</Typography>
          </div>
          <div className="contact-item">
            <LocationOnIcon className="contact-icon" />
            <Typography variant="body1" className="contact-text">Samastipur, Bihar (848101)</Typography>
          </div>
        </div>
        
        {/* Back Button */}
        <Link to="/Services">
          <button className="comic-button">Back</button>
        </Link>
      </Grid>
      
      {/* Right side with content */}
      <Grid item xs={12} md={8} className="webdevelopment-content">
        <CardContent>
          <Typography variant="h4" component="div" gutterBottom className="webdevelopment-title">
            Digital Marketing Solutions
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Search Engine Optimization (SEO):</strong> Improving website rankings on search engines through on-page and off-page optimization.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Pay-Per-Click (PPC) Advertising:</strong> Managing paid ad campaigns on platforms like Google Ads and Facebook Ads.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Social Media Marketing:</strong> Creating and executing social media strategies to engage audiences.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Content Marketing:</strong> Developing and promoting high-quality content to attract and retain customers.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Email Marketing:</strong> Designing and managing email campaigns for lead nurturing and customer engagement.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Analytics and Reporting:</strong> Tracking and analyzing marketing campaign performance using tools like Google Analytics.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Influencer Marketing:</strong> Collaborating with influencers to promote products or services.
          </Typography>
          
          <Typography variant="body1" paragraph className="webdevelopment-text">
            <strong>Brand Strategy and Development:</strong> Creating a cohesive brand strategy to enhance visibility and reputation.
          </Typography>
        </CardContent>
      </Grid>
    </Card>
  );
};

export default Digitalmarketing;
